import { render, staticRenderFns } from "./MemberWriteCuratorLayout.vue?vue&type=template&id=65c944fa&scoped=true&"
import script from "./MemberWriteCuratorLayout.vue?vue&type=script&lang=js&"
export * from "./MemberWriteCuratorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c944fa",
  null
  
)

export default component.exports